import { getUserData } from '../helpers';

const isTimesheetApproval = getUserData('isTimesheetApproval');

export const timesheetApproval = (state = isTimesheetApproval, action) => {
  switch (action.type) {
    case 'ENABLE_TS_APPROVAL':
      return true;
    case 'DISABLE_TS_APPROVAL':
      return false;
    default:
      return state;
  }
};
